import { SWRConfiguration } from "swr";
import useQuery from "../api/useQuery";
import { EmailNotificationConfig, QueryEmailNotificationConfig } from "../../api/dtos/dtos";

const useQueryEmailNotificationConfig = (query?: Partial<QueryEmailNotificationConfig>, configuration?: SWRConfiguration) => {
    return useQuery<EmailNotificationConfig, QueryEmailNotificationConfig>(QueryEmailNotificationConfig, query, configuration);
}

export default useQueryEmailNotificationConfig;